import PageMeta from "../../components/common/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignUpForm from "../../components/common/auth/SignUpForm";

export default function SignUp() {
  return (
    <>
      <PageMeta
        title="Sign Up | Casekeep - Secure File Sharing for Small Business"
        description="Create your free Casekeep account. Join the beta to securely collect and share sensitive client documents with the highest encryption standards. No client logins required."
      />
      <AuthLayout>
        <SignUpForm />
      </AuthLayout>
    </>
  );
}
